// Componentes específicos de Sucursal
import SvlpComponentBannerText from "../../components/sucursal-virtual/SvlpComponentBannerText.vue";
import SvlpComponentNavBarHeader from "../../components/sucursal-virtual/SvlpComponentNavBarHeader.vue";
import SvlpComponentFooter from "../../components/sucursal-virtual/SvlpComponentFooter.vue";
import SucursalIndex from "./SucursalIndex.vue";

const sucursalApp = new Vue({
  el: "#sucursal-app",
  components: {
    SvlpComponentBannerText,
    SvlpComponentNavBarHeader,
    SvlpComponentFooter,
    SucursalIndex,
  },
  data() {
    return {
      searchQuery: "",
    };
  },
  methods: {
    searchBranches() {
      // Lógica para buscar sucursales
    },
  },
});

window.sucursalApp = sucursalApp;